var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0357 21.0151C13.9561 19.9025 11.336 18.5031 8.82031 17.1636C10.627 19.8324 12.7884 23.0135 14.8776 26.0884C15.2671 26.6617 15.654 27.2313 16.0357 27.793V21.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 21.0151C18.1108 19.9025 20.7309 18.5031 23.2466 17.1636C21.4399 19.8324 19.2786 23.0135 17.1893 26.0884C16.7999 26.6617 16.4128 27.2313 16.0312 27.793V21.0151Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0357 4.31982L8.82031 14.9123L16.0357 11.1038V4.31982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 4.31982L23.2466 14.9123L16.0312 11.1038V4.31982Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0307 16.0439H9.12502L9.10156 16.0564L16.0307 19.7387V16.0439Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0307 16.0439H9.12502L9.10156 16.0312L16.0307 12.3491V16.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 16.0439H22.937L22.9604 16.0564L16.0312 19.7387V16.0439Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 16.0439H22.937L22.9604 16.0312L16.0312 12.3491V16.0439Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_2486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetc);
export default __webpack_public_path__ + "static/media/metc.3b7521088ba447291be4314025b9dbf7.svg";
export { ForwardRef as ReactComponent };